import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cm-hamburger-icon',
  templateUrl: 'hamburger-icon.component.html',
  styleUrls: ['hamburger-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HamburgerIconComponent {}
